import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useRequireUser } from '../hooks';

export function RequireUser({ children }) {
  const {
    isBlocked,
    location,
    redirectTo
  } = useRequireUser();

  if (isBlocked) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return children;
}

export default RequireUser;

RequireUser.propTypes = {
  children: PropTypes.node.isRequired
};
